import { render } from "./DExpand.vue?vue&type=template&id=1cb6c50d&scoped=true"
import script from "./DExpand.vue?vue&type=script&lang=js"
export * from "./DExpand.vue?vue&type=script&lang=js"

import "./DExpand.vue?vue&type=style&index=0&id=1cb6c50d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb6c50d"]])

export default __exports__